export const baseOfMeta = {
  title: '磐石保經線上投保平台',
  meta: [
    { 
      name: 'descrption', 
      content: '磐石的願景是成為全球保險企業的典範，以兩岸三地的市場資源、產壽合營、虛實整合，共同架構大中華區域為基礎，邁向全球市場。磐石是以愛為核心的企業，因為愛，持守終身服務的承諾，專業創新，成為資產安全的守護者。' 
    },
    {
      property: 'og:title',
      content: '磐石保經線上投保平台',
      vmid: 'og:title'
    },
    {
      property: 'og:description',
      content: '磐石的願景是成為全球保險企業的典範，以兩岸三地的市場資源、產壽合營、虛實整合，共同架構大中華區域為基礎，邁向全球市場。磐石是以愛為核心的企業，因為愛，持守終身服務的承諾，專業創新，成為資產安全的守護者。',
      vmid: 'og:description'
    },
    {
      property: 'og:image',
      content: 'https://scontent.ftpe8-1.fna.fbcdn.net/v/t1.0-9/11255402_1044180718966456_678752712372678742_n.png?_nc_cat=109&_nc_ht=scontent.ftpe8-1.fna&oh=22709df8eaf745e8a30000c3def87a1b&oe=5C782328',
      vmid: 'og:image'
    }
  ]
};

export const insuOfTravel = {
  titleTemplate: '%s | 旅平險',
  meta: [
    {
      property: 'og:title',
      content: '磐石保經 - 旅遊平安險',
      vmid: 'og:title'
    },
    {
      property: 'og:description',
      content: '國內外安心出遊，玩得盡興。出門旅遊，旅平險準備好了嗎？出發前1小時也可以保，保額、方案自由選擇，3分鐘迅速完保超輕鬆！',
      vmid: 'og:description'
    }
  ]
};

export function InsuranceMeta() {
  let subTitle = '旅平險';
  switch (this.currentType) {
    case ('car'):
      subTitle = '汽車險';
      break;
    case ('motor'):
      subTitle = '機車險';
      break;
    case ('accident'):
      subTitle = '傷害險';
      break;
    case ('pet'):
      subTitle = '寵物險';
      break;
    case ('vaccine'):
      subTitle = '疫苗險防疫險';  //20210530 Wen Add 首頁 banners區塊試算
      break;
    default:
      break;
  }
  return {
    titleTemplate: `%s | ${subTitle}`,
  };
}